import * as commonModule from '../common';
import axios from 'axios';
import * as variable from './variables';
import * as activists from './functions';
import validators from './validation';

let clarityUserId = null;

// Set the global pathname and attach primary demo form function and file download handler
window.openPrimaryDemoForm = activists.openPrimaryDemoForm;
activists.handleFileDownloadClick('.cta-download-file');

/* global Alpine */
document.addEventListener('alpine:init', () => {
  Alpine.data('formHandler', () => ({
    // Use the window variable for current path name
    currentPathName: window.location.pathname,
    formId: '',
    formData: {
      portalId: '3906991',
      form: null,
      formId: '',
      fields: [],
      url: '',
      data: {
        fields: [],
        context: ''
      }
    },
    loading: false,
    hideFormErrorContent: true, // Boolean to show error div (non-400 error)
    formDataFields: {}, // Object to store the filled data fields in the form
    // Business email error handling
    emailError: false,
    emailErrorMessage: '',
    chromeFeedbackSuccess: false, // For chrome uninstall page success
    signupFormError: false, // For signup form error state
    thankyouform: variable.thankyouformdata, // Common thank you form data
    // Map of thank you page messages
    formSuccessMessages: variable.formSuccessMessages,
    // Map of form IDs
    formIdsMap: variable.formIdsMap,
    // Map of HubSpot form IDs
    hubspotFormIdMap: variable.hubspotFormIdMap,
    // Dropdown selection handling
    dropdownOpened: false,
    dropdownOpened1: false,
    dropdownElementActive: false,
    dropdownElementActive1: false,
    dropdownElementFocus: false,
    demoFormFilled: false,
    partnersFormActive: false,
    gdprConsent: false,
    enterIcon: true,
    // Form fields to be validated
    firstname: '',
    contact_name: '',
    client_fullname: '',
    email: '',
    work_email: '',
    numemployees: '',
    any_other_comments_contact: '',
    phone: '',
    number_of_clients: '',
    partnership_type__referral_reseller_: '',
    what_are_you_looking_for_: '',
    number_of_employees: '',
    partner_type: '',
    active_users_count: '',
    gdpr_consent: false,
    gdpr_consent_partners_referral: false,
    active_employees: '',
    extension_feedback: '',
    // Employee count arrays and other selection options
    employeeNumberArray: [
      'Under 5', '6 to 25', '26 to 50', '51 to 100', '101 to 500', '501 to 1000', 'More than 1000'
    ],
    cocpEmployeeNumberArray: [
      '2-50', '51-200', '201-500', '501-2500', '2500+'
    ],
    clientsNumberArray: [
      '1-10', '10-100', '100-500', '> 500'
    ],
    partnerTypeArray: [
      'Solution Partners', 'Accounting Service Partners', 'Financial Service Partners', 'Travel Partners', 'Resellers and referral partners', 'Other'
    ],
    errors: {},
    isSubmitting: false,

    // Validate a single field if a validator is available for it
    validateField(fieldName) {
      if (validators[fieldName]) {
        // Use the Alpine component’s property, not formData.
        const value = this[fieldName];
        const result = validators[fieldName].call(this, value);
        if (typeof result === 'string') {
          this.errors[fieldName] = result;
        } else {
          delete this.errors[fieldName];
        }
      }
    },

    // Validate all fields in the formData object
    validateAll() {
      // List all fields that need to be validated.
      const fieldsToValidate = [
        'firstname',
        'contact_name',
        'client_fullname',
        'email',
        'work_email',
        'phone',
        'number_of_clients',
        'partnership_type__referral_reseller_',
        'what_are_you_looking_for_',
        'number_of_employees',
        'numemployees',
        'partner_type',
        'active_users_count',
        'gdpr_consent',
        'gdpr_consent_partners_referral',
        'active_employees',
        'extension_feedback',
        'any_other_comments_contact'
      ];
      
      // Validate each field.
      fieldsToValidate.forEach((fieldName) => {
        this.validateField(fieldName);
      });
    },

    getContactDetailsWrapper() {
      this.formDataFields = activists.getContactDetails(this.formData.fields);
    },

    setClarityID: function () {
      if (window.clarity) {
        window.clarity('identify', clarityUserId, {'user_id': clarityUserId });
      }
    },
    
    onFormSubmissionSuccess() {
      activists.handleFormSubmissionSuccess(this);
    },

    onFormSubmissionError(response) {
      if (response && response.status === 400) {
        this.handleDefaultError();
      } else {
        this.handleNon400Error();
      }
    },

    // Renamed for consistency with its call above
    handleDefaultError() {
      this.emailError = true;
      this.errors['email'] = 'Please enter a valid business email to move forward';
    },

    handleNon400Error() {
      if (this.isSpecificFormId()) {
        this.handleFormError();
      } else {
        this.showDefaultErrorModal();
      }
    },

    isSpecificFormId() {
      const specificFormIds = [
        this.formIdsMap.partnerReferralForm,
        this.formIdsMap.contentDownloadOutsideModal,
        this.formIdsMap.contactUsFormOutsideModal,
        this.formIdsMap.contactUsForm,
        this.formIdsMap.accountingFirmsForm,
        this.formIdsMap.contactUsFormExitIntentModal,
        this.formIdsMap.contactUsFormFeatureDownload,
        this.formIdsMap.contentDownloadFormWithDemo,
        this.formIdsMap.minnesotaCocpaFormHubspotId,
        this.formIdsMap.coloradoCocpaFormHubspotId,
        this.formIdsMap.alabamaCocpaFormHubspotId,
        this.formIdsMap.floridaCocpaFormHubspotId,
        this.formIdsMap.bakerTillyWebinarForm,
        this.formIdsMap.contentDownloadReportForm
      ];
      return specificFormIds.includes(this.formId);
    },

    handleFormError() {
      // Show error message and reset form
      this.hideFormErrorContent = false;
      this.resetForm();
    },

    showDefaultErrorModal() {
      // Use jQuery to show a modal error message
      $('#error-form-modal').modal('show');
    },

    resetForm() {
      // Reset all form fields to empty strings
      this.firstname = '';
      this.contact_name = '';
      this.client_fullname = '';
      this.email = '';
      this.work_email = '';
      this.phone = '';
      this.number_of_clients = '';
      this.partnership_type__referral_reseller_ = '';
      this.what_are_you_looking_for_ = '';
      this.number_of_employees = '';
      this.numemployees = '';
      this.partner_type = '';
      this.active_users_count = '';
      this.gdpr_consent = false;
      this.gdpr_consent_partners_referral = false;
      this.active_employees = '';
      this.extension_feedback = '';
      this.any_other_comments_contact = '';
    },

    getFormData(uniqueFormID = null) {
      // If clarity user id is not set, assign a default value
      if (clarityUserId === null) {
        clarityUserId = 'Clarity user id not found';
      }

      // Ensure that the form element reference exists
      if (!this.$refs || !this.$refs.formElement) {
        return;
      }
      
      this.formData.form = this.$refs.formElement;
      // Use uniqueFormID (if provided) to help determine the form ID
      this.formData.formId = this.determineFormId(this.formData.form.id, uniqueFormID);
      // Use a template literal for the URL
      this.formData.url = `https://api.hsforms.com/submissions/v3/integration/submit/${this.formData.portalId}/${this.formData.formId}`;
      // Serialize form fields (adjust as needed for your form structure)
      this.formData.fields = activists.serializeFormFields(this.formData);
      this.formData.data = {
        fields: this.formData.fields,
        context: commonModule.getContext()
      };
    },

    determineFormId(formElementId, uniqueFormID) {
      const formIdMap = variable.formIdMap;
      if (formIdMap[formElementId]) {
        return formIdMap[formElementId];
      }
      // Fallback based on uniqueFormID value
      return (uniqueFormID === 'master-form-submit') ? this.hubspotFormIdMap.masterForm : this.hubspotFormIdMap.partnersStepForm;
    },

    onFormSubmit() {
      this.loading = true;
      axios.post(this.formData.url, this.formData.data)
        .then(() => {
          this.onFormSubmissionSuccess();
          this.loading = false;
        })
        .catch((error) => {
          this.onFormSubmissionError(error.response);
          this.loading = false;
        });
    },

    async submitForm(formId) {
      this.formId = formId;
      this.isSubmitting = true;
      // Validate the form before submitting
      this.validateAll();
      if (Object.keys(this.errors).length > 0) {
        this.isSubmitting = false;
        return;
      }
      // Pass formId (or unique identifier) if needed by getFormData
      this.getFormData(formId);
      this.onFormSubmit();
      this.isSubmitting = false;
    },

    // Updated changeDropdownValue to accept the event as an argument
    changeDropdownValue(fieldName, event) {
      const selectedValue = event.target.innerText;
      if (fieldName === 'number_of_employees') {
        this.number_of_employees = selectedValue;
      } else if (fieldName === 'partner_type') {
        this.partner_type = selectedValue;
      } else if (fieldName === 'number_of_clients') {
        this.number_of_clients = selectedValue;
      } else if (fieldName === 'numemployees') {
        this.numemployees = selectedValue;
      }
      this.validateField(fieldName);
    },
  }));
});
